<template>
  <div :style="[customCss]" class="relative pb-4 w-full">
    <div class="flex items-center justify-between relative">
      <div class="flex w-full mr-4">
        <slot name="course-tile-image"></slot>
        <div class="text-wrapper-t2-tile">
          <div
            class="text-md font-semibold mb-2 body-heading-color title inter-font-regular"
          >
            <slot name="course-tile-title"></slot>
          </div>
          <div class="text-md mb-2 body-content-color description">
            <slot name="course-tile-description"></slot>
          </div>
        </div>
      </div>
      <div class="progress-bar-t2-tile">
        <slot
          v-if="showProgressbar == 1"
          name="course-tile-progress-bar"
        ></slot>
      </div>
    </div>
    <div
      class="absolute w-full h-full left-0 top-0 rounded-lg bg-black-transparent opacity-0 hover:opacity-100 flex items-center justify-center tile-hover-height text-white"
    >
      <slot name="course-tile-type"></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: 'TileV2',
  props: {
    getThemeSettings: {
      type: Function,
      required: true,
    },
    showProgressbar: {},
  },
  computed: {
    customCss() {
      return {
        '--template-body-heading-color': this.themeSettings.body_section
          .body_heading_color,
        '--template-body-content-color': this.themeSettings.body_section
          .body_content_color,
      };
    },
    themeSettings() {
      return this.getThemeSettings();
    },
  },
};
</script>
<style lang="scss">
.course-tile-list-v2 {
  .progress-bar-t2-tile {
    width: 100%;
    max-width: 65px;
    .p-6 {
      padding: 0px;
    }
    .hierarchy-heading-color {
      background: #66c1e1;
    }
  }
  .body-heading-color {
    color: var(--template-body-heading-color);
  }
  .body-content-color {
    color: var(--template-body-content-color);
  }
}
.tile-hover-height {
  height: calc(100% - 16px);
}
.bg-black-transparent {
  background: rgba(41, 44, 72, 0.79);
}
.hover\:opacity-100:hover {
  opacity: 1;
}
.mobile-template {
  .text-wrapper-t2-tile {
    .description {
      max-width: 80%;
    }
  }
}
</style>